module.exports = __webpack_public_path__ + "img/hashtag_SPURS16.ad4857ca.png";